import React from "react";
import { useEditCustomer } from "../hooks/useEditCustomer";
import { useCustomerValidation } from "../hooks/useCustomerValidation";
import GenericForm, { FormFieldConfig } from "src/shared/components/genericform/GenericForm";
import LoadingScreen from "src/shared/components/LoadingScreen";
import { EditCustomerProps } from "src/shared/services/interfacev2";

const EditCustomer: React.FC<EditCustomerProps> = (props) => {
  const {
    formData,
    isLoading,
    handleFirstNameChange,
    handleMiddleNameChange,
    handleLastNameChange,
    handlePhoneChange,
    handleAlternativePhoneChange,
    handleEmailChange,
    handleAddressChange,
    handleAddress2Change,
    handleAddress3Change,
    handleAddress4Change,
    updateCustomer,
    closeEditCustomer,
  } = useEditCustomer(props);

  /** validation */
  const validation = useCustomerValidation({
    formData,
    originalData: {
      firstName: props.firstName,
      middleName: props.middleName || "",
      lastName: props.lastName || "",
      phone: props.phone,
      alternativePhone: props.alternativePhone || "",
      email: props.email || "",
      address: props.address,
      address2: props.address2,
      address3: props.address3,
      address4: props.address4 || "",
      phones: [],
      emails: []
    },
  });

  const isFormValid =
    typeof validation.isFormValid === "function"
      ? validation.isFormValid
      : () => Boolean(validation.isFormValid);

  const adaptChange =
    (handler: (e: React.ChangeEvent<HTMLInputElement>) => void) =>
    (val: string) => {
      if (!isLoading) {
        handler({ target: { value: val } } as React.ChangeEvent<HTMLInputElement>);
      }
    };

  const fields: FormFieldConfig[] = [
    {
      id: "firstName",
      label: "First Name",
      required: true,
      value: formData.firstName,
      onChange: adaptChange(handleFirstNameChange),
      disabled: isLoading,
    },
    {
      id: "middleName",
      label: "Middle Name",
      value: formData.middleName,
      onChange: adaptChange(handleMiddleNameChange),
      disabled: isLoading,
    },
    {
      id: "lastName",
      label: "Last Name",
      value: formData.lastName,
      onChange: adaptChange(handleLastNameChange),
      disabled: isLoading,
    },
    {
      id: "phone",
      label: "Phone Number",
      required: true,
      value: formData.phone,
      onChange: adaptChange(handlePhoneChange),
      // inputRef: inputRefs.phoneNumberRef,
      disabled: isLoading,
    },
    {
      id: "alternativePhone",
      label: "Alternative Phone Number",
      value: formData.alternativePhone,
      onChange: adaptChange(handleAlternativePhoneChange),
      disabled: isLoading,
    },
    {
      id: "email",
      label: "Email",
      value: formData.email,
      onChange: adaptChange(handleEmailChange),
      // inputRef: inputRefs.emailRef,
      disabled: isLoading,
    },
    {
      id: "address-section",
      label: "Address (Optional)",
      type: "section",
    },
    {
      id: "address",
      label: "Street / Village",
      // variant: "standard",
      value: formData.address,
      onChange: adaptChange(handleAddressChange),
      // inputRef: inputRefs.streetRef,
      disabled: isLoading,
    },
    {
      id: "address2",
      label: "District / State",
      // variant: "standard",
      value: formData.address2,
      onChange: adaptChange(handleAddress2Change),
      disabled: isLoading,
    },
    {
      id: "address3",
      label: "City",
      // variant: "standard",
      value: formData.address3,
      onChange: adaptChange(handleAddress3Change),
      disabled: isLoading,
    },
    {
      id: "address4",
      label: "Pincode / Zipcode",
      // variant: "standard",
      value: formData.address4,
      onChange: adaptChange(handleAddress4Change),
      disabled: isLoading,
    },
  ];

  return (
    <>
      <GenericForm
        open={true}
        title="Edit Customer Details"
        fields={fields}
        onClose={closeEditCustomer}
        onSubmit={updateCustomer}
        isFormValid={isFormValid}
        confirmLabel="Update"
        cancelLabel="Cancel"
        isLoading={isLoading}
      />

      {isLoading && <LoadingScreen />}
    </>
  );
};

export default EditCustomer;
